import { render, staticRenderFns } from "./ConfigInputS3Xsl.vue?vue&type=template&id=63430efa&scoped=true&"
import script from "./ConfigInputS3Xsl.vue?vue&type=script&lang=js&"
export * from "./ConfigInputS3Xsl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63430efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63430efa')) {
      api.createRecord('63430efa', component.options)
    } else {
      api.reload('63430efa', component.options)
    }
    module.hot.accept("./ConfigInputS3Xsl.vue?vue&type=template&id=63430efa&scoped=true&", function () {
      api.rerender('63430efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputS3Xsl.vue"
export default component.exports